import formatCurrency from "./format-currency";

const gValue = 136549;
const gDate = "1.5.2026";

function getGValue(multiply) {
  const calcValue = gValue * multiply;

  return formatCurrency(calcValue);
}

export { getGValue, gValue, gDate };
